export const normalizeFin = (fin: string): string => {
    return fin.replace(' ', '');
};
